<template>
  <div class="layout-wrap">
    <Loading />
    <div class="header">
      <!-- 後々画像に置き換える -->
      <span>蔵衛門クラウド α版</span>
    </div>
    <div class="front-wrap">
      <router-view />
    </div>
    <div class="footer">
      <div class="footer-link">
        <a href="https://www.kuraemon.com/contact/?from=cloud" rel="noopener" target="_blank">ヘルプ</a>
        <router-link :to="{ name: 'terms-of-service' }" rel="noopener" target="_blank">利用規約</router-link>
        <a href="https://www.kuraemon.com/privacy/?from=cloud" rel="noopener" target="_blank">プライバシーポリシー</a>
      </div>
      <div class="copyright">
        (c)2020 LECRE Inc.JAPAN. All Rights Reserved
      </div>
    </div>
    <ApiErrorDialog />
  </div>
</template>

<script>
export default {
  components: {
    ApiErrorDialog: () => import('../ui/ApiErrorDialog.vue'),
    Loading: () => import('../ui/Loading.vue')
  }  
}
</script>

<style scoped>
.layout-wrap {
  height: 100%;
}
.header {
  background-color: #333;
  color: white;
  font-size: 2rem;
  font-weight: bold;
  padding: 1rem;
  text-align: center;
}
.front-wrap {
  min-height: calc(100vh - 140px);
}
.footer div {
  padding: 0.5rem;
}
.footer-link, .copyright {
  text-align: center;
}
.footer-link a {
  color: #333;
}
.footer-link a:nth-child(1),
.footer-link a:nth-child(2) {
  margin-right: 0.5rem;
}
</style>